export default __webpack_public_path__ + "img/99a48450c92f7264101dde2d57f16420.svg";